export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
	async loginUser(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$auth
				.loginWith('laravelSanctum', {
					data: payload,
				})
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	async logout() {
		return new Promise((resolve, reject) => {
			this.$auth
				.logout()
				.then((response) => {
					location.reload();
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
